module.exports = __webpack_public_path__ + "img/greyEmptystar.e9dcaa00.svg";